import { c as _c } from "react/compiler-runtime";
import type { Theme } from '@onefootprint/design-tokens';
import type { FootprintAppearance } from '@onefootprint/footprint-js';
import { DesignSystemProvider } from '@onefootprint/ui';
import type React from 'react';
import { useEffect, useState } from 'react';
import type { AppearanceOptions } from '../../../../appearence.types';
import getCustomAppearance from '../../../../utils/get-custom-appearance';
import AppearanceContext from '../../appearance-context';
import ApplyDarkClass from '../apply-dark-class';
import LoadCssVariables from '../load-css-variables';
import LoadRules from '../load-rules';
type LoadAppearanceInBrowserProps = {
  options: AppearanceOptions;
  children: React.ReactNode;
};
const LoadAppearanceInBrowser = t0 => {
  const $ = _c(10);
  const {
    options,
    children
  } = t0;
  const [theme, setTheme] = useState(null);
  const [appearance, setAppearance] = useState(null);
  const [rules, setRules] = useState(null);
  const getObConfig = _temp;
  const getAuthToken = _temp2;
  const getKybBoAuthToken = _temp3;
  let t1;
  if ($[0] !== options) {
    t1 = async () => {
      const obConfig = getObConfig();
      const kybBoAuthToken = getKybBoAuthToken();
      const authToken = kybBoAuthToken ? undefined : getAuthToken();
      const response = await getCustomAppearance({
        ...options,
        obConfig: options.obConfig || obConfig,
        authToken,
        kybBoAuthToken
      });
      setTheme(response.theme);
      setAppearance(response.appearance);
      setRules(response.rules);
    };
    $[0] = options;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const getAppearance = t1;
  let t2;
  if ($[2] !== getAppearance) {
    t2 = () => {
      getAppearance();
    };
    $[2] = getAppearance;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] !== appearance || $[6] !== children || $[7] !== rules || $[8] !== theme) {
    t4 = theme ? <DesignSystemProvider><LoadRules rules={rules} /><LoadCssVariables theme={theme} /><ApplyDarkClass appearance={appearance} /><AppearanceContext.Provider value={appearance}>{children}</AppearanceContext.Provider></DesignSystemProvider> : null;
    $[5] = appearance;
    $[6] = children;
    $[7] = rules;
    $[8] = theme;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default LoadAppearanceInBrowser;
function _temp() {
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);
  if (params.get("type") === "ob_pk") {
    return url.hash.substring(1);
  }
}
function _temp2() {
  const url_0 = new URL(window.location.href);
  return url_0.hash.substring(1);
}
function _temp3() {
  const url_1 = new URL(window.location.href);
  const params_0 = new URLSearchParams(url_1.search);
  const type = params_0.get("type");
  if (!type) {
    return;
  }
  if (type === "bo") {
    return url_1.hash.substring(1);
  }
}